import { Injectable } from '@angular/core';
import { ApiOptions } from '../../worklist/interfaces/export.config.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { map , partialRight, pick , isPlainObject , omit, get ,set ,size,isEmpty} from 'lodash';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import moment from 'moment';
import { DateHandler } from '@ispm/shared/utils/DateHandler';
import {EXPORT_DATA_STORAGE_KEY} from "@ispm/shared/services/ui-customization.service";
import { NOTIFICATION_MESSAGE } from '@ispm-client/modules/aggregator/services/consts';
import {NotificationMessageTypes} from "@ispm/core/constants/notification-message-types.constant";
import {Subject} from "rxjs";
import {ExportNotificationService} from "./export-notification-service";
import {ActivityService} from "@ispm/user/services/activity.service";
import {ExportOptionStatusUpdate} from "../classes/export-options";
import {ExportType} from "../constants/export-types.constant";
import {ActivityActions} from "@ispm/user/constants/activityActions";

@Injectable()
export class DynamicApiService {
  constructor(private _ispmHttpClient: IspmHttpClient,
              private exportNotificationService: ExportNotificationService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private activityService: ActivityService,
              private coreActions: CoreActionCreatorService) {
  }


  private _selectedRows: Array<any> = [];
  private reloadWorklistStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private worklistTemplate: string;


  public setWorklistSelectedRows(selectedRows): void {
    this._selectedRows = selectedRows;
  }

  public getWorklistSelectedRows(): Array<any> {
    return this._selectedRows;
  }

  public setReloadWorklistStatus(status): void {
    this.reloadWorklistStatus.next(status);
  }

  public getReloadWorklistStatus(): Observable<boolean> {
    return this.reloadWorklistStatus.asObservable();
  }

  public setCurrentWorklistTemplate(template) {
    this.worklistTemplate = template;
  }

  /**
   * This method to create a text file and download to the client
   * @param JSONData
   * @param exportTitle
   * @constructor
   */
   JSONToTextConvertor(JSONData, exportTitle) {
    let arrayData: string = '';
    for (const currentData of JSONData) {
      arrayData = arrayData + currentData + '\r\n';
    }
    const blob = new Blob([arrayData], { type: 'text/plain;charset=utf-8' });
    const url = window.URL ;
    const link = url.createObjectURL(blob);
    const element = document.createElement('a');
    const date = new Date();
    const formattedDate = moment(date).format('YYYYMMDD');
    const clientTime24Hours = DateHandler.getTimeStrings(date).time24String;
    const clientTime = clientTime24Hours.replace(new RegExp(':', 'g'), '');
    element.download = exportTitle + '_' + formattedDate + '-' + clientTime + '.txt';
    element.href = link;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  public constructApiCall(apiResource: ApiOptions,isAsync:boolean = false,activity:any = null,startPollingSubject:Subject<any> = null,exportDataOptionStatusUpdateSubject:Subject<any> = null) {
    if (apiResource && this.getWorklistSelectedRows().length) {
      const exportLimit = apiResource.maxExportLimit;
      const payload = apiResource.payloadData && this.generatePayload(apiResource.payloadData,exportLimit);
      const selectedRowCount = get(JSON.parse(sessionStorage.getItem("exportData")),'selectionCount',this.getWorklistSelectedRows().length);
      if (exportLimit && selectedRowCount > exportLimit) {
        this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.INFO,
          this.notificationMessage.ACR_EXPORT_LIMIT_MSG +" "+ exportLimit, null, null,null, false, false, true);
      }
      const exportDataStr = sessionStorage.getItem(EXPORT_DATA_STORAGE_KEY);
      switch (apiResource.httpMethod) {
        case 'GET':
          this._ispmHttpClient.get(apiResource.url) .subscribe( (data) => {
            if (data && apiResource.refreshWorklist) {
              this.setReloadWorklistStatus(true);
            }
          });
          break;
        case 'PUT':
          this._ispmHttpClient.put(apiResource.url, payload) .subscribe( (data) => {
              if (data && apiResource.refreshWorklist) {
                this.setReloadWorklistStatus(true);
              }
            },
            (error) => {
              this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN,this.notificationMessage.SOMETHING_WENT_WRONG_WITH_API_CALL);
            });
          break;
        case 'POST':
          this.coreActions.setLoader(true);
          payload.activity = get(activity,'id',"")
          this._ispmHttpClient.post(apiResource.url, payload)
            .subscribe((result) => {
                if (!isAsync) {
                  //result = excel Base64 data
                  if (result && exportDataStr) {
                    const exportData = JSON.parse(exportDataStr);
                    this.setExportWorklistDataOptionDisabledStatus({
                      disabled: false,
                      exportRunning: false
                    }, exportData['worklistTemplateId'], false, exportDataOptionStatusUpdateSubject);
                    if (result && apiResource.export) {
                      if (apiResource.exportType === 'txt') {
                        if (apiResource.maxServerExportLimit && size(result) == apiResource.maxServerExportLimit) {
                          this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN,this.notificationMessage.ACR_EXPORT_LIMIT_MSG +` ${size(result)} records.`)
                        }
                        this.JSONToTextConvertor(result, apiResource.exportTitle);
                      }
                    }
                    if (result && apiResource.refreshWorklist) {
                      this.setReloadWorklistStatus(true);
                    }
                    this.coreActions.setLoader(false);
                  }
                } else {
                  //result = export data task ID
                  if (result && Object.keys(result).length > 0) {
                    let taskId = result.taskId;
                    this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.INFO, this.notificationMessage.ASYNC_EXPORT_DATA_TO_EXCEL_STARTED, null, 5000);
                    if (activity && activity.context && activity.context.length > 0) {
                      //Set the related task ID to an empty export data activity for the user
                      this.activityService.updateActivityContext(activity, taskId)
                        .catch((err) => {
                          console.error(`sendExportACRData :: activity update error => activity: ${JSON.stringify(activity)} - error: ${err}"`);
                          this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN, err.message || this.notificationMessage.SOMETHING_WENT_WRONG_WITH_API_CALL);
                        })
                        .finally(() => {
                          startPollingSubject.next();
                          this.coreActions.setLoader(false);
                        });
                    }
                    if (isEmpty(taskId)) {
                      //Set the related task ID to an empty export data activity for the user
                      this.activityService.updateActivityAction(activity, activity[ExportType.ACTOR], ActivityActions.FAILED)
                        .catch((err) => {
                          console.error(`updating activity status. TASK did not created
                         :: activity update error. => activity: ${JSON.stringify(activity)} - error: ${err}" ${ActivityActions.FAILED}`);
                          this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN, err.message || this.notificationMessage.SOMETHING_WENT_WRONG_WITH_API_CALL);
                        })
                        .finally(() => {
                          startPollingSubject.next();
                          this.coreActions.setLoader(false);
                        });
                    }
                  }
                }
              },
              (e) => {
                this.coreActions.setLoader(false);
                if (get(e, 'error.validArray', [ ]).length && e.error.valid === false) {
                  e = e.error.validArray.find(err => err.valid === false);
                }
                if(isAsync){
                  this.activityService.updateActivityAction(activity, activity[ExportType.ACTOR], ActivityActions.FAILED)
                    .catch((err) => {
                      console.error(`updating activity status. Failed to create task
                         :: activity update error. => activity: ${JSON.stringify(activity)} - error: ${err}" ${ActivityActions.FAILED}`);
                    })
                    .finally(() => {
                      startPollingSubject.next();
                      this.coreActions.setLoader(false);
                    });
                }
                this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN,e.message || e.error || this.notificationMessage.SOMETHING_WENT_WRONG_WITH_API_CALL);
              });
          break;
        case 'DELETE':
          this._ispmHttpClient.delete(apiResource.url) .subscribe( (data) => {
            if (data && apiResource.refreshWorklist) {
              this.setReloadWorklistStatus(true);
            }
          });
          break;
      }
    } else {
      this.exportNotificationService.setNotificationMessage(NotificationMessageTypes.WARN,this.notificationMessage.NO_ITEMS_SELECTED_FROM_WORKLIST);
    }
  }

  private generatePayload(payloadData,maxExportLimit:number) {
    payloadData[payloadData.identifier] = this.mapFieldsFromWorklist(payloadData);
    payloadData = omit(payloadData, ['identifier', 'pickFromWorklist']);
    payloadData = this.updatePayloadWithSessionStorage(payloadData);
    payloadData = set(payloadData,'maxExportLimit',maxExportLimit);
    return payloadData;
  }

  private mapFieldsFromWorklist(payloadData) {
    if (payloadData) {
      if (payloadData.pickFromWorklist) {
        return isPlainObject(payloadData.pickFromWorklist) ?  this.getWorklistSelectedRows().map((object) =>  this.pickAs(object, payloadData.pickFromWorklist)) :
          map(this.getWorklistSelectedRows(), partialRight(pick, payloadData.pickFromWorklist));
      } else {
        return map(this.getWorklistSelectedRows(), partialRight(pick, 'id'));
      }
    }
  }

  private  pickAs( originalItem: object , pickAsProperties: object) {
    return Object.keys(originalItem).map(key => [key, get(originalItem, pickAsProperties[key])])
      .reduce((accumulator, [key, value]) => {
        if (key in pickAsProperties) { accumulator[key] = value; }
        return accumulator;
      }, { });
  }

  /**
   * This method enrich the information from the export date key from session
   * storage about the current applied filter and ids exlcuded in the worklist
   * @param payloadData
   */
  private updatePayloadWithSessionStorage(payloadData) {
    const cachedExportStr: string = sessionStorage.getItem(EXPORT_DATA_STORAGE_KEY);
    if (cachedExportStr && cachedExportStr !== "") {
      const cachedExport = JSON.parse(cachedExportStr);
      if (cachedExport.hasOwnProperty('query')) {
        payloadData = Object.assign({ "query": cachedExport.query }, payloadData);
        if (cachedExport.hasOwnProperty('currentFields')) {
          payloadData = Object.assign({ "excludedIds": cachedExport.currentFields.resources[0].excludedIds},payloadData);
        }
      }
    }
    return payloadData;
  }

  public setExportWorklistDataOptionDisabledStatus(exportOptionStatusUpdate:ExportOptionStatusUpdate, worklistTemplate: string, isAll: boolean = false,exportDataOptionStatusUpdateSubject:Subject<any>) {
    if (this.worklistTemplate && (this.worklistTemplate === worklistTemplate || isAll))
      exportDataOptionStatusUpdateSubject.next(exportOptionStatusUpdate);
  }

}
